export default __webpack_public_path__ + "static/media/rating-icon.e800fb12.svg";